import slick from '../plugins/slick.js';
import Headroom from '../plugins/headroom.js';
import cookie from '../plugins/jquery.cookie.js';

(function($) {

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Base = {
  // All pages
  common: {
    init: function() {
      /////
      // JavaScript to be fired on all pages
      /////

      // Cookied Popup
      var $delay = 0;
      if ($('.cookied-popup').length) {
        $delay = $('.cookied-popup').data('delay');
        setTimeout(function(){
          $('.cookied-popup').addClass('visible');
        }, $delay);
      }
      $('.close-cookie-popup').on('click', function(){
        $('.cookied-popup').fadeOut();
        $.cookie('popup', $('.cookied-popup').attr('id'), { path: '/' });
      });

      // Pagination
      $('#ajax-pagination').on('click', 'a', function(e){
        e.preventDefault();
        $(this).remove();
        $('#ajax-loader').load($(this).attr('href') + ' #ajax-posts>*', function(){
          $('#ajax-posts').append($('#ajax-loader').html());
        });
        $('#ajax-pagination').load($(this).attr('href') + ' #ajax-pagination>*');
      });

      // Blog Filter
      $('#blog-filter').on('change', function(){
        window.location.href = $(this).find(":selected").val();
      });

      // Formstack Multistep
      $('body').click('.ff-page-bread-item, .ff-btn-next, .ff-btn-prev', function(e){
        $('.ff-page-bread-header').removeClass('complete').removeClass('n1').removeClass('n2').removeClass('n3').removeClass('n4').removeClass('n5');
        if ($('.ff-page-bread-item.item-selected').length) {
          $('.ff-page-bread-header').addClass('n' + $('.ff-page-bread-item.item-selected').attr('data-pagenumber'));
        } else {
          $('.ff-page-bread-header').addClass('complete');
        }
      });

      // Buttons
      $('.btn').each(function(){
        $(this).html('<span>' + $(this).html() + '</span>').after('<br/>');
      });

      // FAQ Accordions
      $('.accordion').click(function(){
        $(this).toggleClass('open');
      });

      // Testimonial Slider
      $('.testimonials-slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 1000,
        fade: false,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: '<div class="prev">&nbsp;</div>',
        nextArrow: '<div class="next">&nbsp;</div>',
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });

      // Meet the Team
      if ($('.meet_the_team-js').length) {
        setInterval(function(){
          var $n = Math.floor((Math.random() * 6) + 1);
          var things1 = $('.meet_the_team-js .team-member:nth-child(' + $n + ') .inner.visible'),
              $this1 = $(things1[Math.floor(Math.random()*things1.length)]);
            $this1.removeClass('visible').css('order', $this1.data('order')).attr('data-ordertwo', $this1.data('order'));
          var things2 = $('.meet_the_team-js .team-member:nth-child(' + $n + ') .inner:not(.visible)'),
              $this2 = $(things2[Math.floor(Math.random()*things2.length)]);
            $this2.css('order', $this1.data('ordertwo')).attr('data-ordertwo', $this1.data('ordertwo')).addClass('visible');
            $this1.attr('data-ordertwo', $this1.data('order'));
        }, 2000);
      }

      // Sticky Header
      if ($('.global-header').length) {
        var myElement = document.querySelector(".global-header");
        var headroom  = new Headroom(myElement, {
          "offset": 210,
          "tolerance": 0
        });
        headroom.init();
      }

      // Status Bar
      $('#status-close').on('click', function(){
        $('.status-bar').css('display', 'none');
        $.cookie('status', $('.status-bar').attr('id'), { path: '/' });
      });

      // Pagination
      $('#pagination').on('click', 'a', function(e){
        e.preventDefault();
        $(this).remove();
        $('#ajax-loader').load($(this).attr('href') + ' #ajax-posts>*', function(){
          $('#ajax-posts').append($('#ajax-loader').html());
        });
        $('#pagination').load($(this).attr('href') + ' #pagination>*');
      });

      // Anchor
      $('a').on('click', function(e){
        var $href = $(this).attr('href'),
            $anchor = $href;
        if ($anchor.indexOf('#') > -1) {
          if (!$anchor.match('^#')) {
            $anchor = $anchor.substr($anchor.indexOf('#'));
          }
          if ($($anchor).length > 0) {
            e.preventDefault();
            $('html, body').stop().animate({
              scrollTop: $($anchor).offset().top
            });
          } else {
            window.location.href = $href;
          }
        }
      });

      // Form Labels
      $('input').on('focus', function(){
        $(this).parent('*').addClass('filled');
      });
      $('input').on('blur', function(){
        if ($(this).val() !== '') {
          $(this).parent('*').addClass('filled');
        } else {
          $(this).parent('*').removeClass('filled');
        }
      });

      // Video popups
      $('a').on('click', function(e){
        var $target = $(this).attr('href');
        if ($target.toLowerCase().indexOf("vimeo") >= 0) {
          e.preventDefault();
          var $n = $target.lastIndexOf('/');
          var $vid = $target.substring($n + 1);
          $('.popup-content').html('<iframe src="https://player.vimeo.com/video/' + $vid + '/?autoplay=1&api=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
          $('.video-popup-wrapper').addClass('active');
          $('body, html').addClass('body-noscroll');
        }
        if ($target.toLowerCase().indexOf("youtu") >= 0) {
          e.preventDefault();
          var $y = $target.lastIndexOf('=');
          var $yid = $target.substring($y + 1);
          $('.popup-content').html('<iframe src="https://www.youtube.com/embed/' + $yid + '/?autoplay=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
          $('.video-popup-wrapper').addClass('active');
          $('body, html').addClass('body-noscroll');
        }
      });
      $('.close-popup').on('click', function(){
        $('.video-popup-wrapper').removeClass('active');
        $('.popup-content').html('');
        $('body, html').removeClass('body-noscroll');
      });

      // Mobile Nav
      $('#mobile-nav-toggle').on('click', function(){
        var $navheight = $('#mobile-navigation').height() + 170;
        $('body, html').toggleClass('nav-locked');
        $('#mobile-navigation-wrapper').toggleClass('active');
        $(this).toggleClass('active');
        window.scrollTo(0, 0);
      });

      // Resize for Match-Height and Slick-Slider glitch fix
      this.scroll_actions;
      $(window).bind('load', function(){
        $(window).trigger('resize');
        setTimeout(function(){ $(window).trigger('resize'); }, 500);
        this.scroll_actions;
      });
      $(document).ready(this.scroll_actions);
      $(window).scroll(this.scroll_actions);
    },
    scroll_actions: function() {
      $('.animate, blockquote').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          $this.addClass('visible');
        }
      });
      $('.animate-1').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 100);
        }
      });
      $('.animate-2').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 200);
        }
      });
      $('.animate-3').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 300);
        }
      });
      $('.animate-4').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 400);
        }
      });
      $('.animate-5').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 500);
        }
      });
      $('.animate-6').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 600);
        }
      });
      $('.animate-7').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 700);
        }
      });
      $('.animate-8').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 800);
        }
      });
      $('.animate-9').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 900);
        }
      });
      $('.animate-10').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1000);
        }
      });
      $('.animate-11').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1100);
        }
      });
      $('.animate-12').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1200);
        }
      });
      $('.animate-13').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1300);
        }
      });
      $('.animate-14').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1400);
        }
      });
      $('.animate-15').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1500);
        }
      });
      $('.animate-16').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1600);
        }
      });
      $('.animate-17').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1700);
        }
      });
      $('.animate-18').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1800);
        }
      });
      $('.animate-19').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1900);
        }
      });
      $('.animate-20').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2000);
        }
      });
      $('.animate-21').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2100);
        }
      });
    }
  },
  // Home page
  home: {
    init: function() {
      // JavaScript to be fired on the home page
    }
  }
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
  fire: function(func, funcname, args) {
    var namespace = Base;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
      namespace[func][funcname](args);
    }
  },
  loadEvents: function() {
    UTIL.fire('common');

    $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
      UTIL.fire(classnm);
    });
  }
};

$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.